module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/sec02_2_pc_c8841c96f2a44c52e4f8455cdc33ab6f.jpg";